// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vCWa9R {
  border-radius: 4px;
  border: 1px solid var(--stroke-neutral-subtle);
  padding: var(--spacing-3);
  flex-grow: 1;
}

.oqMFDf {
  display: flex;
  gap: 0;
  align-items: stretch;
}

.kYo_Q5 {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
  padding-right: var(--spacing-3);
  min-width: 0;
  overflow: hidden;
}

.hmLsvK {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 1;
  gap: 6px;
}

.ba2xKb {
  flex-shrink: 0;
  padding-left: var(--spacing-3);
}

.YYtczc {
  background-color: var(--stroke-neutral-subtle);
  width: 1px;
  align-self: stretch;
}

.ImZknp {
  color: var(--text-neutral-dark);
  line-height: var(--line-height-auto);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  margin: 0;
}

.uu6QHu {
  color: var(--text-neutral-dark);
  font-size: var(--font-size-md);
  line-height: var(--line-height-180);
  margin: 0;
}

.eFRTck {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  min-width: 0;
  width: 100%;
}

.WhgoKY {
  background-color: var(--surface-neutral-pale);
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: 4px;
  padding: 14px 8px;
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  line-height: 20px;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
}

.MBGT_5 {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 160px;
  justify-content: center;
  flex-shrink: 0;
}

.WaumKU {
  width: 16px;
  height: 16px;
}

.wezEUV {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1-5);
}

.orqf7o {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.rezJRS {
  margin: 0;
  color: var(--text-neutral-dark);
  line-height: var(--line-height-auto);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.Pd3NbR {
  position: relative;
  display: inline-block;
}

.KgN8zp {
  width: 120px;
  height: 120px;
}

.IqEjzQ {
  padding: 0;
}

@media (max-width: 768px) {
  .vCWa9R {
    padding: 16px;
  }

  .oqMFDf {
    flex-direction: column;
    gap: 24px;
  }

  .kYo_Q5 {
    padding-right: 0;
    overflow: visible;
  }

  .ba2xKb {
    padding-left: 0;
  }

  .YYtczc {
    display: none;
  }

  .eFRTck {
    flex-direction: column;
    align-items: stretch;
  }

  .WhgoKY {
    white-space: normal;
    word-break: break-all;
    text-overflow: clip;
    overflow: visible;
  }

  .ImZknp {
    font-size: 16px;
  }

  .uu6QHu {
    font-size: 13px;
  }

  .MBGT_5 {
    width: 100%;
    min-width: auto;
  }

  .KgN8zp {
    width: 100px;
    height: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/EmissorPaymentPixPage/components/EmissorPaymentPixCode/EmissorPaymentPixCode.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,MAAM;EACN,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,8CAA8C;EAC9C,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":[".container {\n  border-radius: 4px;\n  border: 1px solid var(--stroke-neutral-subtle);\n  padding: var(--spacing-3);\n  flex-grow: 1;\n}\n\n.pixSection {\n  display: flex;\n  gap: 0;\n  align-items: stretch;\n}\n\n.leftSection {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n  padding-right: var(--spacing-3);\n  min-width: 0;\n  overflow: hidden;\n}\n\n.codeSection {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  flex: 1;\n  gap: 6px;\n}\n\n.rightSection {\n  flex-shrink: 0;\n  padding-left: var(--spacing-3);\n}\n\n.separator {\n  background-color: var(--stroke-neutral-subtle);\n  width: 1px;\n  align-self: stretch;\n}\n\n.title {\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-auto);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  margin: 0;\n}\n\n.description {\n  color: var(--text-neutral-dark);\n  font-size: var(--font-size-md);\n  line-height: var(--line-height-180);\n  margin: 0;\n}\n\n.codeContainer {\n  display: flex;\n  flex-direction: row;\n  gap: 16px;\n  align-items: center;\n  min-width: 0;\n  width: 100%;\n}\n\n.codeText {\n  background-color: var(--surface-neutral-pale);\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: 4px;\n  padding: 14px 8px;\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  line-height: 20px;\n  flex: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.copyButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 160px;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.copyIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.qrSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1-5);\n}\n\n.qrTitleContainer {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.qrTitle {\n  margin: 0;\n  color: var(--text-neutral-dark);\n  line-height: var(--line-height-auto);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n}\n\n.qrCodeContainer {\n  position: relative;\n  display: inline-block;\n}\n\n.qrCodeImage {\n  width: 120px;\n  height: 120px;\n}\n\n.downloadButton {\n  padding: 0;\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 16px;\n  }\n\n  .pixSection {\n    flex-direction: column;\n    gap: 24px;\n  }\n\n  .leftSection {\n    padding-right: 0;\n    overflow: visible;\n  }\n\n  .rightSection {\n    padding-left: 0;\n  }\n\n  .separator {\n    display: none;\n  }\n\n  .codeContainer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .codeText {\n    white-space: normal;\n    word-break: break-all;\n    text-overflow: clip;\n    overflow: visible;\n  }\n\n  .title {\n    font-size: 16px;\n  }\n\n  .description {\n    font-size: 13px;\n  }\n\n  .copyButton {\n    width: 100%;\n    min-width: auto;\n  }\n\n  .qrCodeImage {\n    width: 100px;\n    height: 100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `vCWa9R`,
	"pixSection": `oqMFDf`,
	"leftSection": `kYo_Q5`,
	"codeSection": `hmLsvK`,
	"rightSection": `ba2xKb`,
	"separator": `YYtczc`,
	"title": `ImZknp`,
	"description": `uu6QHu`,
	"codeContainer": `eFRTck`,
	"codeText": `WhgoKY`,
	"copyButton": `MBGT_5`,
	"copyIcon": `WaumKU`,
	"qrSection": `wezEUV`,
	"qrTitleContainer": `orqf7o`,
	"qrTitle": `rezJRS`,
	"qrCodeContainer": `Pd3NbR`,
	"qrCodeImage": `KgN8zp`,
	"downloadButton": `IqEjzQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
